// Typed environment variable access
// Replaces raw process.env.REACT_APP_* usage throughout the app
// Vite exposes REACT_APP_* vars via the reactAppEnvPlugin in vite.config.js
//
// URL keys use getters so they always read the latest value from
// window.__CW_TENANT_URLS__ (populated after tenant init), avoiding
// stale build-time defaults when tenant URLs load after module import.
// Falls back to process.env.REACT_APP_* (Vite-transformed) for browser mode.

const env = {
  // Server URLs — dynamic getters for tenant-aware resolution
  get serverUrl() { return process.env.REACT_APP_serverUrl || ""; },
  get genericUrl() { return process.env.REACT_APP_genericUrl || ""; },
  get signInUrl() { return process.env.REACT_APP_signInUrl || ""; },
  get verifyOtpUrl() { return process.env.REACT_APP_verifyOtpUrl || ""; },
  get domain() { return process.env.REACT_APP_domain || ""; },
  get edcUrl() { return process.env.REACT_APP_edcUrl || ""; },
  get apiUrl() { return process.env.REACT_APP_API_URL || ""; },
  get refreshTokenUrl() { return window.__CW_TENANT_URLS__?.REACT_APP_REFRESHTOKEN_URL || process.env.REACT_APP_REFRESHTOKEN_URL || ""; },

  // SSO / OAuth
  get ssoUrl() { return process.env.REACT_APP_SSOURL || ""; },
  get redirectUrl() { return process.env.REACT_APP_redirectURL || ""; },

  // Sentry (non-URL, static)
  sentryDsn: process.env.REACT_APP_SENTRY_DSN || "",
  sentryEnabled: process.env.REACT_APP_ENABLE_SENTRY === "true",
  sentryEnvironment: process.env.REACT_APP_Sentry_Environment || "development",

  // Feature Flags (non-URL, static)
  instanceType: process.env.REACT_APP_INSTANCE_TYPE || "Enterprise",
  multilingual: process.env.REACT_APP_MULTILINGUAL === "true",
  enableVision: process.env.REACT_APP_ENABLE_VISION === "true",
  ofcScanMode: process.env.REACT_APP_OFC_SCAN_MODE === "true",
  disableAggregatorInvoicePrint: process.env.REACT_APP_DISABLE_AGGREGATOR_INVOICE_PRINT === "true",
  disableAggregatorKotPrint: process.env.REACT_APP_DISABLE_AGGREGATOR_KOT_PRINT === "true",
  printDayEndReport: process.env.REACT_APP_PRINT_DAY_END_REPORT === "true",

  // UI Customization (non-URL, static)
  posBackgroundColor: process.env.REACT_APP_POSBACKGROUND_COLOR || "",
  language: process.env.REACT_APP_LANGUAGE || "English",

  // Versioning — single source of truth: package.json → VITE_APP_VERSION
  releaseNo: import.meta.env.VITE_APP_VERSION || "1.0.0",

  // WebSocket
  get wsUrl() { return process.env.REACT_APP_WS_URL || ""; },
  get socketServerUrl() { return process.env.REACT_APP_SOCKET_SERVER_URL || ""; },

  // Misc (non-URL, static)
  diffHoursDifferentDate: parseInt(process.env.REACT_APP_DIFF_HOURS_DIFFERENT_DATE || "2", 10),
  diffHoursSameDate: parseInt(process.env.REACT_APP_DIFF_HOURS_SAME_DATE || "3", 10),
  sproutzVerifyStock: process.env.REACT_APP_SPROUTZ_VERIFYSTOCK || "",
  get dayEndApplicationUrl() { return window.__CW_TENANT_URLS__?.REACT_APP_DAY_END_APPLICATION_URL || process.env.REACT_APP_DAY_END_APPLICATION_URL || ""; },
};

export default env;
